<template>
  <div
    class="avatar bg-color-green d-flex justify-content-center align-items-center"
  >
    <h4 class="h4 m-0 font-bold text-uppercase">{{ formatText }}</h4>
  </div>
</template>

<script>
export default {
  name: "TextAvatarComponent",
  computed: {
    formatText() {
      const words = this.text.trim().split(/\s+/);
      if (words.length >= 2) {
        return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
      }
      return this.text.slice(0, 2).toUpperCase();
    }
  },
  props: {
    text: {
      default: "Mydessk"
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
